export default __webpack_public_path__ + "static/1-7752f38902bf31fdec00a3384716a8d9.jpg";